import { useEffect, useState } from "react";

export default function TopBar() {
    const [time, setTime] = useState(new Date());

    // Live time updater
    useEffect(() => {
        const timer = setInterval(() => setTime(new Date()), 1000);
        return () => clearInterval(timer);
    }, []);

    // Mobile time
    const mobileTime = time.toLocaleString("en-IN", {
        day: "2-digit",
        month: "short",
        hour: "2-digit",
        minute: "2-digit",
        hour12: true,
    });

    // Desktop time
    const desktopTime = time.toLocaleString("en-IN", {
        weekday: "short",
        day: "2-digit",
        month: "short",
        year: "numeric",
        hour: "2-digit",
        minute: "2-digit",
        second: "2-digit",
        hour12: true,
    });

    return (
        <div className="w-full text-white text-xs lg:text-sm sticky top-0 z-50">

            {/* ================= MOBILE VIEW ================= */}
            <div className="lg:hidden">

                {/* Top Row */}
                <div className="flex items-center justify-between bg-[#0b2f57] px-4 py-1.5">
                    <span className="font-semibold">{mobileTime}</span>
                    <span title="User" className="cursor-pointer text-base opacity-80">
                        👤
                    </span>
                </div>

                {/* Bottom Row */}
                <div className="flex flex-wrap justify-center gap-x-6 gap-y-1 bg-[#083b6b] py-2 border-t border-white/10">
                    <a href="/contact" className="hover:underline">Contact</a>
                    <a href="/about" className="hover:underline">About</a>
                    <a href="/privacy-policy" className="hover:underline opacity-80">Privacy</a>
                    <a href="/terms-conditions" className="hover:underline opacity-80">Terms</a>
                    <a href="/login" className="hover:underline">Login</a>
                </div>
            </div>

            {/* ================= DESKTOP VIEW ================= */}
            <div className="hidden lg:flex bg-[#083b6b] px-6 py-2 justify-between items-center">

                {/* LEFT LINKS */}
                <nav className="flex items-center space-x-4">
                    <a href="/contact" className="hover:underline">Contact</a>
                    <a href="/about" className="hover:underline">About Us</a>
                    <a href="/privacy-policy" className="hover:underline">Privacy Policy</a>
                    <a href="/terms-conditions" className="hover:underline">Terms & Conditions</a>
                </nav>

                {/* RIGHT SECTION */}
                <div className="flex items-center space-x-4">
                    <span className="font-semibold whitespace-nowrap">
                        {desktopTime}
                    </span>

                    <a href="/login" className="hover:underline">
                        Login / Register
                    </a>

                    <span title="User" className="cursor-pointer text-lg opacity-80">
                        👤
                    </span>
                </div>
            </div>
        </div>
    );
}
